'use client';

import { useTranslations } from 'next-intl';
import { VStack } from '@terra/ui-styled-system';
import { Tabs } from '../../../components/tabs';
import {
  ApplicationGlobalHeadersEditor,
  type ApplicationGlobalHeadersEditorProps,
} from './ApplicationGlobalHeadersEditor';
import {
  ApplicationInternalAccessSettings,
  type ApplicationInternalAccessSettingsProps,
} from './ApplicationInternalAccessSettings';

export type ApplicationNetworkingSectionProps = {
  internalAccessSettings: Omit<
    ApplicationInternalAccessSettingsProps,
    'isReadOnly'
  >;
  globalHeaders: Omit<ApplicationGlobalHeadersEditorProps, 'isReadOnly'>;
  isReadOnly?: boolean;
};

export function ApplicationNetworkingSection({
  internalAccessSettings,
  globalHeaders,
  isReadOnly,
}: ApplicationNetworkingSectionProps) {
  const t = useTranslations('designSystem.applicationSettings.networking');

  return (
    <VStack alignItems="stretch" gap={8} w="full">
      <Tabs.Root defaultValue="internal" size="sm">
        <Tabs.List>
          <Tabs.Trigger value="internal">{t('isInternalApp')}</Tabs.Trigger>
          <Tabs.Trigger value="headers">{t('globalHeaders')}</Tabs.Trigger>
          <Tabs.Indicator />
        </Tabs.List>
        <Tabs.Content value="internal">
          <ApplicationInternalAccessSettings
            {...internalAccessSettings}
            isReadOnly={isReadOnly}
          />
        </Tabs.Content>
        <Tabs.Content value="headers">
          <ApplicationGlobalHeadersEditor
            {...globalHeaders}
            isReadOnly={isReadOnly}
          />
        </Tabs.Content>
      </Tabs.Root>
    </VStack>
  );
}
